module.exports = __webpack_public_path__ + "static/media/close-circle.555074a5.svg";